var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOvertime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#D34829"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    stroke: "#9097A5",
    strokeOpacity: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7931 12.7297V9.28813C23.9326 9.12288 23.0578 9.02647 22.1787 9H22.002C19.4565 9.04896 16.9801 9.7598 14.8677 11.0479C12.7553 12.336 11.096 14.147 10.0872 16.2654C9.07838 18.3838 8.76266 20.7203 9.17761 22.9967C9.59256 25.2731 10.7207 27.3934 12.4277 29.1053C13.545 30.3714 14.9743 31.3826 16.6008 32.0578C18.2273 32.7329 20.0058 33.0531 21.7936 32.9928C23.5814 32.9325 25.3287 32.4933 26.8953 31.7104C28.462 30.9275 29.8043 29.8228 30.8146 28.4849C31.8249 27.1469 32.475 25.613 32.7128 24.0062C32.9507 22.3994 32.7696 20.7645 32.1841 19.2326C31.5986 17.7007 30.625 16.3144 29.3415 15.1851C28.0579 14.0558 26.5001 13.2149 24.7931 12.7297ZM21.2601 30.722C19.481 30.722 17.7419 30.2438 16.2629 29.3478C14.7839 28.4518 13.6315 27.1783 12.9515 25.6886C12.2715 24.1988 12.0944 22.5598 12.4428 20.9788C12.7912 19.3979 13.6493 17.9461 14.9085 16.8073C16.1677 15.6684 17.7715 14.8937 19.5168 14.5811C21.2621 14.2685 23.0706 14.4322 24.7132 15.0513C26.3559 15.6705 27.7589 16.7173 28.7447 18.0593C29.7306 19.4013 30.255 20.9781 30.2515 22.5903C30.2421 24.7471 29.2913 26.813 27.6066 28.3366C25.9219 29.8602 23.6403 30.7178 21.2601 30.722ZM20.0236 22.9424L17.4268 25.2955L19.1933 26.8963L22.4966 23.8709V16.6195H20.0236V22.9424Z",
    fill: "#D34829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvertime);
export default __webpack_public_path__ + "static/media/overtime.eea1bc8e12e1f703c2f151b6bcffd2ea.svg";
export { ForwardRef as ReactComponent };